<template>
<Main :v-loading="$store.state.showLoading"
      :itemsMenuNavegacio="[]"
      :itemsBarraPrincipal="itemsBarraPrincipal"
      :hasMenu="false"
      :titolApp="titolApp"
      linkInformacio="https://memoriadigital.upc.edu/participa"
      :show-watermark="false"
      :show-alert="false"
      :mostraBreadCrumb="false"
      :tagversion="version"
      :contacte="myContacte"
  >

</Main>
  
</template>

<script>

import 'element-plus/theme-chalk/index.css'
import { Main } from '@f1/upc-webapp-ui-vue3'
import MySuggestionsLink from '@/components/MySuggestionsLink'
import Idioma from '@/components/CustomIdioma'
import Perfil from '@/components/CustomPerfil'
import { markRaw } from "vue"
import ContacteApp from '@/components/ContacteApp'

export default {
  name: 'App',
  components: {
      Main
  },
  data() {
      return {
      }
  },
  computed: {
      version() {
          const { version } = require('../package.json')
          return version
      },
      titolApp() {
          return this.$t("Ajuda'ns a completar la catalogació")
      },

      myPerfil() {
            if (this.$oidc.isAuthenticated) {
                return {
                    component: markRaw(Perfil),
                    props: {
                        nom: this.$oidc.user.profile.preferred_username,
                        email: this.$oidc.user.profile.email.toLowerCase(),
                    }       
                }
            } else {
                return undefined;
            }
       },
       itemsBarraPrincipal() {
            var items = [{ component: markRaw(MySuggestionsLink) },{ component: markRaw(Idioma) }]

            if (this.myPerfil != undefined) {
                items.push(this.myPerfil)
            } 
            return items;
       },
       myContacte() {
        return ContacteApp 
       }
  }
}
</script>
